import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import Vue from 'vue'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import moment from 'moment'
import router from './router'
import store from './store/store';
import axios from 'axios';
import _ from 'lodash';

Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.config.ignoredElements = [/^ion-/];

var configFile;

if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
  configFile = "/config.Production.json";
}
else if (process.env.NODE_ENV === 'staging')
{
  configFile = "/config.Staging.json";
}
else if (process.env.NODE_ENV === 'development')
{
  configFile = "/config.Development.json";
}

Vue.use(Vuelidate);

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
});

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
});

Object.defineProperty(Vue.prototype, '$moment', { value: moment });

fetch(configFile)
  .then(r => r.json())
  .then(json => {
    axios.defaults.baseURL = json.API_URL;
    Object.defineProperty(Vue.prototype, '$ApiBaseUrl', { value: json.API_URL });
    Object.defineProperty(Vue.prototype, '$PaymentController', { value: json.PAYMENT_CONTROLLER_URL });
    new Vue({
      el: '#app',
      router,
      store,
      render: h => h(App)
    })
  });
